module.exports = __webpack_public_path__ + "img/uy.6068a81.svg";